import React from 'react';
import { withRouter } from 'inferno-router';
import {
  StyleSheet,
  View,
  ScrollView,
  Text,
} from './components/base_components';

import { BusyComponent, BusyOverlay } from './components/busy_component';
import Header from './components/header';
import Link from './components/link';
import ProgressSpinner from './components/progress_spinner';
import TextButton from './components/buttons/text_button';

import DeviceStore from './stores/device_store';
import UserStore from './stores/user_store';

const LOGO_IMG = require('./assets/img/logo.png');

const styles = StyleSheet.create({
  deviceScreen: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'transparent',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
  scroller: {
    flex: 1,
    alignSelf: 'stretch',
    flexDirection: 'column',
  },
  scrollInner: {
    paddingLeft: '3em',
    paddingRight: '3em',
    paddingTop: '1em',
    paddingBottom: '5em',
    alignSelf: 'stretch',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    overflowY: 'scroll',
  },
  top: {
    alignSelf: 'stretch',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  fill: {
    flex: 1,
  },
  logo: {
    width: '8em',
    height: '8em',
    marginRight: '1em',
  },
  line: {
    alignSelf: 'stretch',
    height: '1px',
    backgroundColor: 'black',
  },
  headerText: {
    color: '#444',
    fontSize: '1.4em',
    fontWeight: 'bold',
  },
  list: {
    marginTop: '1em',
    marginBottom: '1em',
  },
  add: {
    marginTop: '1em',
  },
  volumeList: {
    marginTop: '0.5em',
    marginBottom: '1em',
    flexDirection: 'column',
  },
  volume: {
    flexDirection: 'column',
  },
  itemLine: {
    marginTop: '0.5em',
    marginBottom: '0.5em',
  },
  value: {
    width: '20em',
  },
  itemButton: {
    height: '2em',
  },
  topText: {
    marginTop: '0.3em',
    fontSize: '1.2em',
  },
  link: {
    marginTop: '1em',
  },
  topLine: {
    marginTop: '1em',
    marginBottom: '0.5em',
  },
});

type Props = {};
type State = {
  device_id: number;
  is_admin: boolean;
  volume_list: [any] | null;
  media_list: [any] | null;
  media_detail: any | null;
};

export default class DeviceScreen extends BusyComponent<Props, State> {
  constructor(props: Props, context: any) {
    super(props, context);

    const device_id = parseInt(props.match.params.device_id) || 0;
    this.state = {
      user: UserStore.getUser(),
      device_id,
      media_list: null,
      media_detail: null,
    };
  }
  componentDidMount() {
    const { device_id } = this.state;
    DeviceStore.addChangeListener(this._onUpdate);
    DeviceStore.fetchDevice(device_id);
    this._onUpdate();
  }
  componentWillUnmount() {
    DeviceStore.removeChangeListener(this._onUpdate);
  }
  _onUpdate = () => {
    const { device_id } = this.state;
    const device = DeviceStore.getDevice(device_id);
    this.setState({ device });
  };

  render() {
    const { user, device, device_id } = this.state;
    const { is_admin } = user;

    let volumes = null;
    if (!device) {
      volumes = <ProgressSpinner />;
    } else if (device.volume_list.length === 0) {
      volumes = <Text style={styles.noMedia}>No Volumes</Text>;
    } else {
      volumes = [];
      device.volume_list.forEach((v, i) => {
        if (!v.is_disabled && !v.is_volume_disabled) {
          volumes.push(<Volume key={i} volume={v} deviceId={device_id} />);
        }
      });
    }
    let admin_button = null;
    if (is_admin) {
      const url = `/admin/device/${device_id}`;
      admin_button = (
        <Link style={styles.link} text='Device Admin' href={url} />
      );
    }

    return (
      <View style={styles.deviceScreen}>
        <ScrollView
          style={styles.scroller}
          contentContainerStyle={styles.scrollInner}
        >
          <Header />
          <Text style={styles.topText}>
            Device: {device && device.device_name}
          </Text>
          <Text style={styles.topText}>User: {device && device.user_name}</Text>
          {admin_button}
          <Line style={styles.topLine} />
          <View style={styles.volumeList}>{volumes}</View>
        </ScrollView>
        <BusyOverlay isBusy={this.state.is_busy} />
      </View>
    );
  }
}

function Line(props) {
  return <View style={[styles.line, props.style]} />;
}

function ItemLine(props) {
  const { value, onPress } = props;
  const buttonText = props.buttonText || 'info';

  return (
    <View style={styles.itemLine}>
      <Text style={styles.value}>{value}</Text>
      <TextButton
        style={styles.itemButton}
        text={buttonText}
        onPress={onPress}
      />
    </View>
  );
}
const Volume = withRouter((props) => {
  const { volume, history, deviceId } = props;
  const { volume_id, volume_name } = volume;
  function _onPress() {
    history.push(`/device/${deviceId}/volume/${volume_id}`);
  }

  return <ItemLine value={volume_name} onPress={_onPress} />;
});
